import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { AuthenticationService } from "app/service/authentication.service";

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {

  constructor(public authenticationService: AuthenticationService,
    public router: Router) { }

  ngOnInit() {

    if (this.authenticationService.isSignedInAdmin()) {
      return setTimeout(
        () => {
          this.router.navigate(['/']);
        }, 5000
      );

    } else {
      return setTimeout(
        () => {
          this.router.navigate(['/']);
        }, 5000
      );

    }

  }

}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/not-found/not-found.component.ts